<template>
  <v-container pa-0>
    <v-row>
      <div class="page__title">
        <div>
          <h1>Partnerzy</h1>
        </div>
      </div>
    </v-row>

    <list-wrapper :total="count" :per-page="12">
      <v-row v-if="count">
        <v-col v-for="(partner, index) in partners" :key="index" cols="12" xl="3" lg="4" sm="6" xs="12">
          <partner :partner="partner" />
        </v-col>
      </v-row>

      <v-row v-else>
        <v-col>
          <p>- Brak wyników -</p>
        </v-col>
      </v-row>
    </list-wrapper>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

import Partner from '@/components/cards/Partner';
import ListWrapper from '@/components/list/ListWrapper';
import { listMixin } from '@/mixins/listMixin';
import { partnerFilters } from '@/utils/partner';

// @vuese
// Lista partnerów
// @group partner
export default {
  components: { ListWrapper, Partner },
  mixins: [listMixin('partner')],
  computed: mapState({ partners: state => state.partner.list, count: state => state.partner.count }),
  methods: {
    filters(route) {
      return partnerFilters(route);
    }
  }
};
</script>
